import { ErrorHandler, Injectable } from '@angular/core';

import { ApplicationError } from '../../error-handler/error-handler.service';
import { JsonElementParser } from '../utilities/json-element-parser.utility';

@Injectable({
    providedIn: 'root'
})
export class ConfigParserService {

    constructor(private readonly globalErrorHandler: ErrorHandler) {
    }

    public parse<T>(configElementId: string): T {
        try {
            return JsonElementParser.parseJsonElementWithId(configElementId) as T;
        } catch (ex) {
            const wrappedError = new ApplicationError(`Failure to parse ${configElementId} from response`, ex);
            this.globalErrorHandler.handleError(wrappedError);
        }
        return null;
    }
}
